<script>
import { $axios } from '@/modules/http/axios'
import Navbar from '@/components/Navbar.vue'
import draggable from 'vuedraggable'
import Swal from 'sweetalert2'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'VehiclesFilter',
  components: { Navbar, draggable },
  data () {
    return {
      drag: false,
      filtersConfig: [],
      vehiclesIds: [],
      notHiddenVehiclesIds: [],
      initialFiltersConfig: false
    }
  },
  created () {
    this.fetchVehicles().then(() => {
      this.vehiclesIds = this.vehicles.map(v => v.id)
      this.notHiddenVehiclesIds = this.notHiddenVehicles.map(v => v.id)
      this.fetchFiltersConfig()
    })
  },
  computed: {
    ...mapGetters({
      vehicles: 'webConfigVehicles/getVehicles',
      notHiddenVehicles: 'webConfigVehicles/getNotHiddenVehicles'
    })
  },
  methods: {
    ...mapActions({
      fetchVehicles: 'webConfigVehicles/fetchVehicles'
    }),

    async fetchFiltersConfig () {
      try {
        let filterVehiclesIds = (await $axios.get('WebConfiguration/VehiclesFilter')).data.value.data
        filterVehiclesIds = filterVehiclesIds.filter(f => this.notHiddenVehiclesIds.includes(f))
        this.notHiddenVehiclesIds.map(id => {
          if (!filterVehiclesIds.includes(id)) {
            filterVehiclesIds.push(id)
          }
        })
        filterVehiclesIds.map(id => this.filtersConfig.push(this.vehicles.find(v => v.id === id)))
      } catch (e) {
        console.log(e)
        if (e.response?.status === 404) {
          this.initialFiltersConfig = true
          this.filtersConfig = this.vehicles
        } else {
          await Swal.fire('Nie udało się pobrać konfiguracji listy ciągników', '', 'error')
        }
      }
    },
    async setFiltersConfig () {
      const filtersConfig = { data: [] }
      this.filtersConfig.map(c => filtersConfig.data.push(c.id))

      try {
        if (this.initialFiltersConfig) {
          await $axios.post('WebConfiguration/VehiclesFilter', filtersConfig)
          this.initialFiltersConfig = false
        } else {
          await $axios.put('WebConfiguration/VehiclesFilter', filtersConfig)
        }
        await Swal.fire('Zapisano nową kolejność', '', 'success')
      } catch (e) {
        await Swal.fire('Nie udało się zapisać konfiguracji', '', 'error')
      }
    },
    async deleteFiltersConfig () {
      const dialog = await Swal.fire({
        title: 'Czy na pewno usunąć tą kolejność ciągników ?',
        icon: 'question',
        showCancelButton: true,
        showConfirmButton: true,
        cancelButtonText: 'Anuluj',
        confirmButtonText: 'Usuń'
      })

      if (dialog.isConfirmed) {
        try {
          await $axios.delete('WebConfiguration/VehiclesFilter')
          await this.fetchFiltersConfig()
        } catch (e) {
          await Swal.fire('Nie udało się usunąć kolejności', '', 'error')
        }
      }
    }
  }
}
</script>

<template>
  <Navbar/>
  <div class="my-1">
    <div id="heading-bar" class="row my-3">
      <div class="d-flex justify-content-start align-items-center">
        <h5 class="fw-bold mb-0 ms-1">
          KONFIGURACJA KOLEJNOŚCI WYŚWIETLANIA CIĄGNIKÓW
        </h5>
      </div>
    </div>
    <div class="container">
      <button class="btn btn-success mb-3" @click="setFiltersConfig">
        Zapisz poniższą kolejność
      </button>

<!--      <button class="btn btn-danger mb-3 ms-2" @click="deleteFiltersConfig">-->
<!--        Usuń poniższą kolejność-->
<!--      </button>-->

      <ul class="list-group">
        <draggable
          v-model="filtersConfig"
          @start="drag = true"
          @end="drag = false"
          item-key="id">
          <template #item="{element}">
            <li class="list-group-item">{{ element.plateNumber }}</li>
          </template>
        </draggable>
      </ul>
    </div>
  </div>
</template>

<style scoped>
.list-group-item {
  cursor: pointer;
}

.list-group-item:hover {
  background: azure;
}
</style>
